export default "__VITE_ASSET__CA0epU9y__"